import "./App.css";
import { Routes, Route } from "react-router-dom";
import Toaster from "./dist/Toaster";
import Layout from "./components/Layout";
import Login from "./pages/login";
import Dashboard from "./pages/dashboard";
import AddEmployeeForm from "./pages/AddEmployeeForm";
import SelectEmployee from "./pages/SelectEmployee";
import EditEmployeeForm from "./pages/EditEmployeeForm";
import UserPanel from "./pages/UserPanel";
import EmployeeStatutoryDetails from "./pages/EmployeeStatutoryDetails";
import EmployeeHistory from "./pages/EmployeeHistory";
import ResignedEmployee from "./pages/ResignedEmployee";
import City from "./pages/city";
import Area from "./pages/area";
import RetainDeleteArea from "./pages/RetainDeleteArea";
import AddCityHQ from "./pages/AddCityHQ";
import AddRoute from "./pages/AssignRoutes";
import EditRoute from "./pages/EditEmployeeRoutes";
import AddStockist from "./pages/AddStockist";
import StockistList from "./pages/StockistList";
import EditStockist from "./pages/EditStockist";
import EmployeeStockistList from "./pages/EmployeeandStockist";
import StockistMissedCall from "./pages/StockistMissedCall";
import MobileRegister from "./pages/MobileRegister";
import LatestBatteryStats from "./pages/LatestBatteryStats";
import BatteryStatsTable from "./pages/BatterStatsTable";
import EmployeeDeviceCount from "./pages/EmployeeDeviceCount";
import SOBTarget from "./pages/SOBTarget";
import EditSOBTarget from "./pages/editSOBTarget";
import UploadSOBTarget from "./pages/uploadSOBTarget";
import POBTarget from "./pages/POBTarget";
import EditPOBTarget from "./pages/editPOBTarget";
import UploadPOBTarget from "./pages/uploadPOBTarget";
import DCRLeaveApplication from "./pages/dcrLeaveApplication";
import LeaveRemarksPage from "./pages/LeaveRemarksPage";
import UnlockDCR from "./pages/UnlockDCR";
import UnfreezeLocation from "./pages/UnfreezeLocation.js";
import DCRLeaveTypePage from "./pages/DCRLeaveTypePage";
import DeleteDCRPage from "./pages/DeleteDCR";
import RemoveDuplicateChemistPage from "./pages/DeleteChemist";
import EditRetailer from "./pages/EditRetailer";
import EditDoctor from "./pages/EditDoctor";
import TourProgram from "./pages/TourProgram";
import AddTourProgram from "./pages/AddTourProgram";
import SendMail from "./pages/SendMail";
import PobData from "./pages/PobData";
import DoctorDetails from "./pages/DoctorDetails";
import ChemistDetails from "./pages/ChemistDetails";
import StockistDetails from "./pages/StockistDetails";
import PobFY from "./pages/PobFY";
import PobDatewise from "./pages/PobDatewise";
import PobdatewiseDetails from "./pages/PobdatewiseDetails";
import SobFY from "./pages/SobFY";
import StockistFY from "./pages/StockistFY";
import MessageEMP from "./pages/MessageEMP";
import MessageStockist from "./pages/MessageStockist";
import DCSAssigned from "./pages/DCSAssigned";
import DailyPunchedAttendence from "./pages/DailyPunchedAttendence";
import MSLPOB from "./pages/MSLPob";
import MSLPobOrganogram from "./pages/MSLPobOrganogram";
import FieldForce from "./pages/FieldForce";
import Doc_Cchem from "./pages/doc_chem.js";
import CallDetails from "./pages/Call_details";
import DCRPunchedAttendence from "./pages/DCRPunchedAttendence";
import AttendenceSheet from "./pages/AttendenceSheet";
import EmployeeStateWise from "./pages/EmployeeStateWise";
import ActualWorking from "./pages/ActualWorking";
import DFR from "./pages/DFr";
import DailyAnalysis from "./pages/DailyAnalysis";
import SobTargetStockist from "./pages/SobTargetStockist";
import StockistPOBSOBTargetADD from "./pages/StockistPOBSOBTargetADD";
import StockistPOBSOBTarget from "./pages/StockistPOBSOBTarget";
import StockistPOBSOBTargetQuarterly from "./pages/StockistPOBSOBTargetQuarterly";
import EmployeePOBSOBTarget from "./pages/EmployeePOBSOBTarget";
import EmployeePOBSOBTargetQuarterly from "./pages/EmployeePOBSOBTargetQuarterly";
import DCRMonthlyPOBInSlabScheme from "./pages/DCRMonthlyPOBInSlabScheme";
import StockistVisitReport from "./pages/StockistVistReport";
import DcrMonthlyPOBStockistSlabEmployeeReport from "./pages/DcrMonthlyPOBStockistSlabEmployeeReport";
import ChemistCallFrequency from "./pages/ChemistCallFrequency";
import PunchedAttendenceStateWise from "./pages/PunchedAttendenceStateWise";
import ChemistMissedCall from "./pages/ChemistMissedCall";
import LocationMRvsMGR from "./pages/LocationMRvsMGR";
import PobDetailsDoctorChemist from "./pages/PobDetailsDoctorChemist";
import PobDetailsDoctorChemistDatewise from "./pages/PobDetailsDoctorChemistDatewise";
import PobDetailsDoctorChemistStockistwise from "./pages/PobDetailsDoctorChemistStockistwise";
import PobDetailsStockist from "./pages/PobDetailsStockist";
import LocationHistorySMS from "./pages/LocationHistorySMS";
import ProtectedRoute from "./components/ProtectedRoute";
import SobEmployeeTargetReport from "./pages/SobEmployeeTargetReport";
import PobEmployeeTargetReport from "./pages/PobEmployeeTargetReport";
import AssignedCity from "./pages/AssigneCity";
import NonVisitRetailer from "./pages/NonVisitRetailers";
import EditEmployeeExpense from "./Admin/EditEmployeeExpense";
import EmployeeExpense from "./Admin/EmployeeExpense";
import ExpenseHistory from "./Admin/ExpenseHistory";
import TravelPolicy from "./Admin/TravelPolicy";
import StateWiseProduct from "./Admin/coordinator/Cosmacia/StateWiseProduct";
import AddProduct from "./Admin/Product/AddProduct";
import EditProduct from "./Admin/Product/EditProduct";
import AddCategory from "./Admin/Product/AddCategory";
import SchemeProduct from "./Admin/Product/SchemeProduct";
import DeleteProduct from "./Admin/Product/DeleteProduct";
import ProductPrice from "./Admin/Product/ProductPrice";
import ProductReport from "./Admin/Product/ProductReport";
import AddBonusScheme from "./Admin/Product/AddBonusScheme";
import EditBonusScheme from "./Admin/Product/EditBonusScheme";
import Cosmacia from "./Admin/coordinator/Cosmacia/Cosmacia";
import CosmaciaScheme from "./Admin/coordinator/Cosmacia/CosmaciaScheme";
import ProductList from "./Admin/coordinator/Cosmacia/ProductList";
import CosmaciaProductWiseScheme from "./Admin/coordinator/Cosmacia/CosmaciaProductWiseScheme ";
import CosmaciaProductWiseSale from "./Admin/coordinator/Cosmacia/CosmaciaProductWiseSale";
import KpKbScheme from "./Admin/coordinator/KPKB/CosmaciaScheme";
import MonthlyProductSales from "./Admin/coordinator/KPKB/MonthlyProductSales";
import MonthlyProductSalesPot from "./Admin/coordinator/KPKB/MonthlyProductSalesPob";
import MonthlyProductSalesQtr from "./Admin/coordinator/KPKB/MonthlyProductSalesQty";
import KpKbProductList from "./Admin/coordinator/KPKB/KpKbProductList";
import KpKbStateWiseProduct from "./Admin/coordinator/KPKB/StateWiseProduct";
import KpKbProductSalesInSlab from "./Admin/coordinator/KPKB/ProductSalesInSlab";
import AddState from "./Admin/AddState";
import AddSubstate from "./Admin/AddSubstate";
import AddDesignation from "./Admin/AddDesignation";
import AddDivision from "./Admin/AddDivision";
import CompanySchemes from "./Admin/CompanySchemes";
import AddDistributor from "./Admin/AddDistributor";
import ViewDistributor from "./Admin/ViewDistributor";
import Schemes from "./Admin/Scheme";
import ProductSalesSlab from "./Admin/coordinator/Cosmacia/ProductSalesInSlab";
import RtrSchemeReport from "./Admin/RtrSchemeReport";
import BroadcastMessage from "./Admin/BroadcastMessage";
import AddBroadCastMessage from "./Admin/AddBroadCastMessage";
import ExpenseApprovedReports from "./Admin/Expense/ExpenseApprovedReports";
import ExenseReports from "./Admin/Expense/ExpenseReports";
import ViewExpense from "./Admin/Expense/ViewExpense";
import ExpenseFf from "./Admin/Expense/ExpenseFf";
import LogoutAllUsers from "./Admin/LogoutAllUsers";
import ExpensePrint from "./Admin/Expense/ExpensePrint";
import ExtraTeam from "./Admin/ExtraTeam";
import EmployeeRights from "./Admin/EmployeeRights";
import RrrRrports from "./Admin/RrrRrports";
import RRRReports from "./Admin/RRRReports/RRRReports";
import RouteRrrDetails from "./Admin/RRRReports/RouteRrrDetails";
import PobRrrDoctorChemist from "./Admin/RRRReports/PobRrrDoctorChemist";
import PobDatewiseData from "./Admin/TablesSheets/PObDateWiseData";
// import DynamicMap from "./Admin/TablesSheets/DynamicMap";
import EmployeeMapTracker from "./pages/EmployeeMapTracker.js";
import AttendanceData from "./Admin/TablesSheets/AttendanceData";
import ProductCampaignDailyReport from "./Admin/Tempation/ProductCampaignDailyReport.js";
import MonthCount from "./Admin/Tempation/MonthCount";
import ProductWiseTemptation from "./Admin/Tempation/ProductWiseTemptation";
import StateWiseProductTemptation from "./Admin/Tempation/StateWiseProductTemptation";
import DealDelightFFCount from "./DealDelight/DealDelightFFCount";
import DealDelightMonthly from "./DealDelight/DealDelightMonthly";
// small UI components / pages that wrap table components
import AttendanceTable from "./Admin/DailyPunchSheets/AttendanceTable";
import DCRPreviewTable from "./Admin/DailyPunchSheets/DcrPreviewTable";
import IdleTimeTable from "./Admin/DailyPunchSheets/IdleTimeTable";
import LocationHistoryTable from "./Admin/DailyPunchSheets/LocationHistoryTime";
import LocationTimeTable from "./Admin/DailyPunchSheets/LocationTimeTable";
import WorkingWithTable from "./Admin/DailyPunchSheets/WorkingWithTable";
import SmsModal from "./Admin/DailyPunchSheets/SmsModal";
import ActualWork from "./Admin/ActualWorking/ActualWork";
import EmployeeWorkingReport from "./Admin/ActualWorking/EmployeeWorkingReport";
import LocationHistoryTime from "./Admin/ActualWorking/LocationHistoryTime";
import LocationDetailPage from "./Admin/ActualWorking/LocationDetailPage";
import ClientDetailPage from "./Admin/ActualWorking/ClientDetailPage";
import DashboardAccess from "./Admin/DashboardAccess";
import DcrMonthlyRetail from "./Admin/DcrMonthlyRetail";
import RemoveLeaves from "./Admin/RemoveLeaves";
import FakeReportingWifiMockGls from "./Admin/FakeReportingWifiMockGls";
import StockistsTable from "./Admin/StockistsTable";
import ChemistsTable from "./Admin/ChemistTable.js";
import DoctorTable from "./Admin/DoctorTable.js";
import AbsentDailyPunch from "./Admin/AbsentDailyPunch.js";
import useAutoRefresh from "./useAutoRefresh.js";
import DoctorsInTPvsDCR from "./Admin/DoctorsInTPvsDCR";
import BulkUpload from ".//Admin/DataUploadSystem/Endpoint";
import PrivacyPolicy from "./pages/PrivacyPolicy.js";
import { initializeTokenRefresh } from "./axiosConfig.js";

function AppContent() {
  initializeTokenRefresh();
  useAutoRefresh();
  return (
    <>
      <Toaster />
      <Routes>
        {/* Public */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        {/* Protected */}
        <Route element={<Layout />}>
         <Route path="/policy/privacy-policy" element={<PrivacyPolicy />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/add-employee" element={<AddEmployeeForm />} />
            <Route path="/select-employee" element={<SelectEmployee />} />
            <Route
              path="/edit-employee/:employeeId"
              element={<EditEmployeeForm />}
            />
            <Route path="/user-panel" element={<UserPanel />} />
            <Route
              path="/statutory-details"
              element={<EmployeeStatutoryDetails />}
            />
            <Route path="/employee-history" element={<EmployeeHistory />} />
            <Route path="/resigned-employee" element={<ResignedEmployee />} />
            <Route path="/city" element={<City />} />
            <Route path="/add-city-hq" element={<AddCityHQ />} />
            <Route path="/assigned-city" element={<AssignedCity />} />
            <Route path="/area" element={<Area />} />
            <Route path="/retaindeletearea" element={<RetainDeleteArea />} />
            <Route path="/addroute" element={<AddRoute />} />
            <Route path="/editroute" element={<EditRoute />} />
            <Route path="/addstockist" element={<AddStockist />} />
            <Route path="/liststockist" element={<StockistList />} />
            <Route
              path="/admin/fake-reporting-wifi-mock-gls"
              element={<FakeReportingWifiMockGls />}
            />
            <Route path="/admin/doctors/:routeId" element={<DoctorTable />} />
            <Route
              path="/admin/chemists/:routeId"
              element={<ChemistsTable />}
            />
            <Route
              path="/admin/stockists/:routeId"
              element={<StockistsTable />}
            />
            <Route
              path="/admin/absent-daily-punch"
              element={<AbsentDailyPunch />}
            />
            <Route
              path="/editstockist/:stockist_code"
              element={<EditStockist />}
            />
            <Route
              path="/employeestockist-list"
              element={<EmployeeStockistList />}
            />
            <Route
              path="/stockistmissedcall-list"
              element={<StockistMissedCall />}
            />
            <Route path="/mobile-register" element={<MobileRegister />} />
            <Route
              path="/admin/latest-Battery-stats"
              element={<LatestBatteryStats />}
            />
            <Route
              path="/admin/Battery-stats"
              element={<BatteryStatsTable />}
            />
            <Route
              path="/registered-device"
              element={<EmployeeDeviceCount />}
            />
            <Route path="/sob-employee-target" element={<SOBTarget />} />
            <Route
              path="/editsob-employee-target"
              element={<EditSOBTarget />}
            />
            <Route
              path="/sob-employee-target-report"
              element={<SobEmployeeTargetReport />}
            />
            <Route
              path="/pob-employee-target-report"
              element={<PobEmployeeTargetReport />}
            />
            <Route path="/uploadsob-target" element={<UploadSOBTarget />} />
            <Route path="/pob-employee-target" element={<POBTarget />} />
            <Route
              path="/editpob-employee-target"
              element={<EditPOBTarget />}
            />
            <Route path="/uploadpob-target" element={<UploadPOBTarget />} />
            <Route
              path="/leave-application"
              element={<DCRLeaveApplication />}
            />
            <Route path="/leave-remarks" element={<LeaveRemarksPage />} />
            <Route path="/unlock-dcr" element={<UnlockDCR />} />
            <Route path="/unfreeze-location" element={<UnfreezeLocation />} />
            <Route path="/leavetype-dcr" element={<DCRLeaveTypePage />} />
            <Route path="/deletedcr" element={<DeleteDCRPage />} />
            <Route
              path="/ViewChemist"
              element={<RemoveDuplicateChemistPage />}
            />
            <Route path="/NonVisitRetailer" element={<NonVisitRetailer />} />
            <Route path="/edit-retailer" element={<EditRetailer />} />
            <Route path="/edit-doctor" element={<EditDoctor />} />
            <Route path="/tour-program" element={<TourProgram />} />
            <Route path="/addtour-program" element={<AddTourProgram />} />
            <Route path="/sendmail" element={<SendMail />} />
            <Route path="/pobdata" element={<PobData />} />
            <Route
              path="/admin/doctors-in-tp-vs-dcr"
              element={<DoctorsInTPvsDCR />}
            />
            
            <Route
              path="/doctordetails/:employeeId"
              element={<DoctorDetails />}
            />
            <Route
              path="/doctordetails/:employeeId/:type"
              element={<DoctorDetails />}
            />
            <Route
              path="/chemistdetails/:employeeId"
              element={<ChemistDetails />}
            />
            <Route
              path="/stockistdetails/:employeeId"
              element={<StockistDetails />}
            />
            <Route path="/pobfy" element={<PobFY />} />
            <Route path="/pobdatewise" element={<PobDatewise />} />
            <Route
              path="/pobdatewisedetails"
              element={<PobdatewiseDetails />}
            />
            <Route path="/sobfy" element={<SobFY />} />
            <Route path="/stockistsobfy" element={<StockistFY />} />
            <Route path="/messageemp" element={<MessageEMP />} />
            <Route path="/messagestockist" element={<MessageStockist />} />
            <Route path="/dcsassigned" element={<DCSAssigned />} />
            <Route
              path="/dailypunchedattendence"
              element={<DailyPunchedAttendence />}
            />
            <Route path="/mslpob" element={<MSLPOB />} />
            <Route path="/mslpoborganogram" element={<MSLPobOrganogram />} />
            <Route path="/fieldforcedata" element={<FieldForce />} />
            <Route path="/calldetails/:employeeId" element={<CallDetails />} />
            <Route
              path="/dcrpunchedattendence"
              element={<DCRPunchedAttendence />}
            />
            <Route path="/admin/broadcast-message" element={<BroadcastMessage />}/>
              <Route path="/admin/add-broadcast-message" element={<AddBroadCastMessage />}/>
            <Route path="/attendencesheet" element={<AttendenceSheet />} />
            <Route path="/employeestatewise" element={<EmployeeStateWise />} />
            <Route path="/actualworking" element={<ActualWorking />} />
            <Route path="/dfr" element={<DFR />} />
            <Route path="/dailyanalysis" element={<DailyAnalysis />} />
            <Route path="/sobtargetstockist" element={<SobTargetStockist />} />
            <Route
              path="/stockistpobsobadd"
              element={<StockistPOBSOBTargetADD />}
            />
            <Route
              path="/stockistpobsobtarget"
              element={<StockistPOBSOBTarget />}
            />
            <Route
              path="/stockistpobsobtargetquarterly"
              element={<StockistPOBSOBTargetQuarterly />}
            />
            <Route
              path="/employeepobsobtarget"
              element={<EmployeePOBSOBTarget />}
            />
            <Route
              path="/employeepobsobtargetquarterly"
              element={<EmployeePOBSOBTargetQuarterly />}
            />
            <Route
              path="/dcrmonthlyinslabscheme"
              element={<DCRMonthlyPOBInSlabScheme />}
            />
            <Route
              path="/stockistvisitreport"
              element={<StockistVisitReport />}
            />
            <Route
              path="/dcrmonthlypobstockistslabemployeereport"
              element={<DcrMonthlyPOBStockistSlabEmployeeReport />}
            />
            <Route
              path="/chemistcallfrequency"
              element={<ChemistCallFrequency />}
            />
            <Route path="/chemistmissedcall" element={<ChemistMissedCall />} />
            <Route
              path="/punchedattendencestatewise"
              element={<PunchedAttendenceStateWise />}
            />
            <Route path="/locationmrvsmgr" element={<LocationMRvsMGR />} />
            <Route
              path="/pob-details-doctor-chemist/:employeeId"
              element={<PobDetailsDoctorChemist />}
            />
            <Route
              path="/pob-details-doctor-chemist-datewise/:employeeId"
              element={<PobDetailsDoctorChemistDatewise />}
            />
            <Route
              path="/pob-details-doctor-chemist-stockistwise/:employeeId"
              element={<PobDetailsDoctorChemistStockistwise />}
            />
            <Route
              path="/pob-details-stockist/:employeeId"
              element={<PobDetailsStockist />}
            />
            <Route
              path="/admin/dcrpreviewtable"
              element={<DCRPreviewTable />}
            />
            <Route path="/admin/idle-time-report" element={<IdleTimeTable />} />
            <Route
              path="/admin/location-history"
              element={<LocationHistoryTable />}
            />
            <Route
              path="/admin/location-time"
              element={<LocationTimeTable />}
            />
            <Route path="/admin/working-with" element={<WorkingWithTable />} />
            <Route
              path="/reporting/employee-working"
              element={<EmployeeWorkingReport />}
            />
            <Route
              path="/reporting/location-history"
              element={<LocationHistoryTime />}
            />
            <Route
              path="/reporting/location-detail"
              element={<LocationDetailPage />}
            />
            <Route
              path="/reporting/client-detail"
              element={<ClientDetailPage />}
            />
            <Route
              path="/pob-details-doctor-chemists/:employeeId"
              element={<PobRrrDoctorChemist />}
            />
            <Route
              path="/admin/Pobdatewise-attendancedata"
              element={<AttendanceData />}
            />
            <Route
              path="/route-details/:routeId?"
              element={<RouteRrrDetails />}
            />
            <Route
              path="/admin/dcr/dcrmonthlyretailPOBInSlab"
              element={<DcrMonthlyRetail />}
            />
            {/* //Actual working rroutes */}
            <Route path="/reporting/actual-working" element={<ActualWork />} />
            <Route
              path="/locationhistorysms"
              element={<LocationHistorySMS />}
            />
            <Route path="/hr/leaveRemove" element={<RemoveLeaves />} />
            {/* Cosmacia */}
            <Route element={<ProtectedRoute cosmacia />}>
              <Route path="/ffmonthlycount" element={<Cosmacia />} />
              <Route path="/cosmacia-scheme" element={<CosmaciaScheme />} />
              <Route path="/cosmacia-product-list" element={<ProductList />} />
              <Route
                path="/cosmacia-product-sales-slab"
                element={<ProductSalesSlab />}
              />
              <Route
                path="/state-wise-product-set"
                element={<StateWiseProduct />}
              />
              <Route
                path="/cosmacia-product-wise-scheme"
                element={<CosmaciaProductWiseScheme />}
              />
              <Route
                path="/cosmacia-product-wise-sale"
                element={<CosmaciaProductWiseSale />}
              />
            </Route>
            {/* KPKB */}
            <Route element={<ProtectedRoute kpkb />}>
              <Route path="/kpkb-scheme" element={<KpKbScheme />} />
              <Route
                path="/kpkb-monthly-sales"
                element={<MonthlyProductSales />}
              />
              <Route
                path="/kpkb-monthly-sales-pot"
                element={<MonthlyProductSalesPot />}
              />
              <Route
                path="/kpkb-monthly-sales-qtr"
                element={<MonthlyProductSalesQtr />}
              />
              <Route path="/kpkb-product-list" element={<KpKbProductList />} />
              <Route
                path="/kpkb-product-sales-in-slab"
                element={<KpKbProductSalesInSlab />}
              />
              <Route
                path="/kpkb-state-wise-product"
                element={<KpKbStateWiseProduct />}
              />
              <Route
                path="/kpkb-product-wise-scheme"
                element={<CosmaciaProductWiseScheme />}
              />
              <Route
                path="/kpkb-product-wise-sale"
                element={<CosmaciaProductWiseSale />}
              />
            </Route>
            <Route path="/admin/rrr-report" element={<RRRReports />} />
            <Route path="/admin/Report-schemes" element={<Schemes />} />
            <Route
              path="/admin/rtr-schemereport"
              element={<RtrSchemeReport />}
            />
            <Route
              path="/admin/product-campaign-temptation"
              element={<ProductCampaignDailyReport />}
            />
            <Route
              path="/admin/MonthCount-temptation"
              element={<MonthCount />}
            />
            <Route
              path="/admin/product-wise-temptation"
              element={<ProductWiseTemptation />}
            />
            <Route
              path="/admin/stateWise-temptation"
              element={<StateWiseProductTemptation />}
            />
            <Route
              path="/admin/deal-delight-ff-count"
              element={<DealDelightFFCount />}
            />
            <Route
              path="/admin/deal-delight-monthly"
              element={<DealDelightMonthly />}
            />
            <Route
              path="/admin/expense/expense-report-view/:empid/:monthyear"
              element={<ExpenseApprovedReports />}
            />
            <Route
              path="/expense/edit-monthly-ff"
              element={<ExenseReports />}
            />
            <Route path="/expense/expense-report-fff" element={<ExpenseFf />} />
            <Route path="/expense/expense-print" element={<ExpensePrint />} />
            
            <Route path="/admin/Expense-history" element={<ExpenseHistory />} />
            <Route path="/admin/travel-policy" element={<TravelPolicy />} />
            {/* Admin-only */}
            <Route element={<ProtectedRoute admin />}>
              <Route path="/admin/add-product" element={<AddProduct />} />
              <Route path="/admin/edit-product" element={<EditProduct />} />
              <Route path="/admin/delete-product" element={<DeleteProduct />} />
              <Route path="/admin/product-price" element={<ProductPrice />} />
              <Route path="/admin/scheme-product" element={<SchemeProduct />} />
              <Route path="/admin/product-report" element={<ProductReport />} />
              <Route path="/admin/add-category" element={<AddCategory />} />
              <Route path="/admin/data-script" element={<BulkUpload />} />
              <Route path="/admin/edit-employee-expense" element={<EditEmployeeExpense />}/>
              <Route path="/admin/add-bonus-scheme" element={<AddBonusScheme />}/>
              <Route path="/admin/edit-bonus-scheme" element={<EditBonusScheme />}/>
              <Route path="/admin/Expense-management" element={<EmployeeExpense />}/>
              <Route path="/admin/edit-employee-expense" element={<EditEmployeeExpense />}/>
              <Route path="/admin/add-state" element={<AddState />} />
              <Route path="/admin/add-substate" element={<AddSubstate />} />
              <Route path="/admin/dashboard-access" element={<DashboardAccess />}/>
              <Route path="/admin/add-designation" element={<AddDesignation />}/>
              <Route path="/admin/company-schemes" element={<CompanySchemes />}/>
              <Route path="/admin/add-division" element={<AddDivision />} />
              <Route path="/admin/add-distributors" element={<AddDistributor />}/>
              <Route path="/admin/view-distributors" element={<ViewDistributor />}/>
              <Route path="/admin/logout-all-users" element={<LogoutAllUsers />}/>
              <Route path="/admin/extrateam" element={<ExtraTeam />} />
              <Route path="/admin/employee-rights" element={<EmployeeRights />}/>
              <Route path="/admin/rrr" element={<RrrRrports />} />
              <Route path="/admin/PobDatewiseData" element={<PobDatewiseData />}/>
              <Route path="/map/employee-map-tracker/:locId" element={<EmployeeMapTracker />}/>
              <Route path="/admin/attendance-table" element={<AttendanceTable />}/>
            </Route>
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default function App() {
  return <AppContent />;
}
